<template>
  <v-card>
    <v-card-text>
      <!-- <message :messages="messages"></message> -->
      <form data-vv-scope="headerForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs6 md2 lg2 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.survNo }}</v-subheader>
              <div class="queryValue">{{ headerForm.survNo }}</div>
            </v-flex>
            <v-flex xs6 md2 lg2 v-else>
              <v-text-field
                :label="labels.survNo"
                v-model="headerForm.survNo"
                :error-messages="errors.collect('headerForm.survNo')"
                data-vv-name="headerForm.survNo"
                :data-vv-as="labels.survNo"
                v-validate="'entry|required'"
                :loading="loading"
                :disabled="true"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md1 lg1 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.verCnt }}</v-subheader>
              <div class="queryValue">{{ headerForm.verCnt }}</div>
            </v-flex>
            <v-flex xs6 md2 lg2 v-else>
              <v-text-field
                :label="labels.verCnt"
                v-model="headerForm.verCnt"
                :error-messages="errors.collect('headerForm.verCnt')"
                data-vv-name="headerForm.verCnt"
                :data-vv-as="labels.verCnt"
                v-validate="'entry|required'"
                :disabled="true"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.survId }}</v-subheader>
              <div class="queryValue">{{ headerForm.survId }}</div>
            </v-flex>
            <v-flex xs6 md2 lg2 v-else>
              <v-text-field
                :label="labels.survId"
                v-model="headerForm.survId"
                :error-messages="errors.collect('headerForm.survId')"
                data-vv-name="headerForm.survId"
                :data-vv-as="labels.survId"
                append-icon="mdi-magnify"
                @click:append="getHelpList('survId')"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.survDate }}</v-subheader>
              <div class="queryValue">{{ formatDate(headerForm.survDate) }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <cal-picker
                v-model="headerForm.survDate"
                :label="labels.survDate"
                :data-vv-as="labels.survDate"
                data-vv-name="headerForm.survDate"
                v-validate="'entry'"
              />
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.polNo }}</v-subheader>
              <div class="queryValue">{{ headerForm.polNo }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.polNo"
                v-model="headerForm.polNo"
                :error-messages="errors.collect('headerForm.polNo')"
                data-vv-name="headerForm.polNo"
                :data-vv-as="labels.polNo"
                :disabled="true"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.insdName }}</v-subheader>
              <div class="queryValue">{{ headerForm.insdName }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.insdName"
                v-model="headerForm.insdName"
                :error-messages="errors.collect('headerForm.insdName')"
                data-vv-name="headerForm.insdName"
                :data-vv-as="labels.insdName"
                v-validate="'entry|max:50'"
              ></v-text-field>
            </v-flex>
            <v-flex md6 lg6></v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.bldgNo }}</v-subheader>
              <div class="queryValue">{{ headerForm.bldgNo }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.bldgNo"
                v-model="headerForm.bldgNo"
                :error-messages="errors.collect('headerForm.bldgNo')"
                data-vv-name="headerForm.bldgNo"
                :data-vv-as="labels.bldgNo"
                v-validate="'entry|max:30'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.unitNo }}</v-subheader>
              <div class="queryValue">{{ headerForm.unitNo }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.unitNo"
                v-model="headerForm.unitNo"
                :error-messages="errors.collect('headerForm.unitNo')"
                data-vv-name="headerForm.unitNo"
                :data-vv-as="labels.unitNo"
                v-validate="'entry|max:30'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.addr1 }}</v-subheader>
              <div class="queryValue">{{ headerForm.addr1 }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.addr1"
                v-model="headerForm.addr1"
                :error-messages="errors.collect('headerForm.addr1')"
                data-vv-name="headerForm.addr1"
                :data-vv-as="labels.addr1"
                v-validate="'entry|max:40'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.addr2 }}</v-subheader>
              <div class="queryValue">{{ headerForm.addr2 }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.addr2"
                v-model="headerForm.addr2"
                :error-messages="errors.collect('headerForm.addr2')"
                data-vv-name="headerForm.addr2"
                :data-vv-as="labels.addr2"
                v-validate="'entry|max:40'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.addr3 }}</v-subheader>
              <div class="queryValue">{{ headerForm.addr3 }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.addr3"
                v-model="headerForm.addr3"
                :error-messages="errors.collect('headerForm.addr3')"
                data-vv-name="headerForm.addr3"
                :data-vv-as="labels.addr3"
                v-validate="'entry|max:40'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.addr4 }}</v-subheader>
              <div class="queryValue">{{ headerForm.addr4 }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.addr4"
                v-model="headerForm.addr4"
                :error-messages="errors.collect('headerForm.addr4')"
                data-vv-name="headerForm.addr4"
                :data-vv-as="labels.addr4"
                v-validate="'entry|max:40'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.postCode }}</v-subheader>
              <div class="queryValue">{{ headerForm.postCode }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.postCode"
                v-model="headerForm.postCode"
                :error-messages="errors.collect('headerForm.postCode')"
                data-vv-name="headerForm.postCode"
                :data-vv-as="labels.postCode"
                v-validate="'entry|max:8'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.survType }}</v-subheader>
              <div class="queryValue" v-for="item in filterSurvTypeList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="survTypeList"
                v-model="headerForm.survType"
                :label="labels.survType"
                item-text="label"
                item-value="value"
                data-vv-name="headerForm.survType"
                :data-vv-as="labels.survType"
                :error-messages="errors.collect('headerForm.survType')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md2 lg2>
              <v-checkbox
                color="primary"
                :label="labels.extPhoto"
                v-model="headerForm.extPhoto"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md2 lg2>
              <v-checkbox
                color="primary"
                :label="labels.intPhoto"
                v-model="headerForm.intPhoto"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md2 lg2>
              <v-checkbox
                color="primary"
                :label="labels.plans"
                v-model="headerForm.plans"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.adjUnit }}</v-subheader>
              <div class="queryValue">{{ headerForm.adjUnit }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.adjUnit"
                v-model="headerForm.adjUnit"
                :error-messages="errors.collect('headerForm.adjUnit')"
                data-vv-name="headerForm.adjUnit"
                :data-vv-as="labels.adjUnit"
                v-validate="'entry|max:40'"
              ></v-text-field>
            </v-flex>
            <v-flex md6 lg6></v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.contactName }}</v-subheader>
              <div class="queryValue">{{ headerForm.contactName }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.contactName"
                v-model="headerForm.contactName"
                :error-messages="errors.collect('headerForm.contactName')"
                data-vv-name="headerForm.contactName"
                :data-vv-as="labels.contactName"
                v-validate="'entry|max:40'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.telNo }}</v-subheader>
              <div class="queryValue">{{ headerForm.telNo }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.telNo"
                v-model="headerForm.telNo"
                :error-messages="errors.collect('headerForm.telNo')"
                data-vv-name="headerForm.telNo"
                :data-vv-as="labels.telNo"
                v-validate="'entry|max:40'"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-content class="grey lighten-5 elevation-2">
          <template v-slot:header>
            <div xs12 class="v-icon mdi mdi-filter-variant theme--light d-flex">
              <span class="headerTitle">Underwriter's Section</span>
            </div>
          </template>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
                    <v-subheader class="queryLabel">{{ labels.nxtSurvBy }}</v-subheader>
                    <div class="queryValue">{{ headerForm.nxtSurvBy }}</div>
                  </v-flex>
                  <v-flex xs12 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.nxtSurvBy"
                      v-model="headerForm.nxtSurvBy"
                      :error-messages="errors.collect('headerForm.nxtSurvBy')"
                      data-vv-name="headerForm.nxtSurvBy"
                      :data-vv-as="labels.nxtSurvBy"
                      append-icon="mdi-magnify"
                      @click:append="getHelpList('nxtSurvBy')"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
                    <v-subheader class="queryLabel">{{ labels.nxtSurvDate }}</v-subheader>
                    <div class="queryValue">{{ formatDate(headerForm.nxtSurvDate) }}</div>
                  </v-flex>
                  <v-flex xs12 md4 lg4 v-else>
                    <cal-picker
                      v-model="headerForm.nxtSurvDate"
                      :label="labels.nxtSurvDate"
                      :data-vv-as="labels.nxtSurvDate"
                      data-vv-name="headerForm.nxtSurvDate"
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
                    <v-subheader class="queryLabel">{{ labels.recomComp }}</v-subheader>
                    <div class="queryValue" v-for="item in filterRecomCompList" :key="item.label">{{ item.label }}</div>
                  </v-flex>
                  <v-flex xs12 md4 lg4 v-else>
                    <v-autocomplete
                      :items="recomCompList"
                      v-model="headerForm.recomComp"
                      :label="labels.recomComp"
                      item-text="label"
                      item-value="value"
                      data-vv-name="headerForm.recomComp"
                      :data-vv-as="labels.recomComp"
                      :error-messages="errors.collect('headerForm.recomComp')"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 v-if="riskSurveyMode === 'Query'">
                    <v-subheader class="queryLabel">{{ labels.remarks }}</v-subheader>
                    <div class="queryValue">{{ headerForm.remarks }}</div>
                  </v-flex>
                  <v-flex xs12 v-else>
                    <v-textarea
                      v-model="headerForm.remarks"
                      :label="labels.remarks"
                      :error-messages="errors.collect('headerForm.remarks')"
                      v-validate="'max:1000|entry'"
                      data-vv-name="headerForm.remarks"
                      :data-vv-as="labels.remarks"
                      :counter="1000"
                      :rows="8"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
                    <v-subheader class="queryLabel">{{ labels.uwIdConv }}</v-subheader>
                    <div class="queryValue">{{ headerForm.uwIdConv }}</div>
                  </v-flex>
                  <v-flex xs12 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.uwIdConv"
                      v-model="headerForm.uwIdConv"
                      :error-messages="errors.collect('headerForm.uwIdConv')"
                      data-vv-name="headerForm.uwIdConv"
                      :data-vv-as="labels.uwIdConv"
                      v-validate="'entry|max:12'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
                    <v-subheader class="queryLabel">{{ labels.updDate }}</v-subheader>
                    <div class="queryValue">{{ formatDate(headerForm.updDate) }}</div>
                  </v-flex>
                  <v-flex xs12 md4 lg4 v-else>
                    <cal-picker v-model="headerForm.updDate" :label="labels.updDate" :data-vv-as="labels.updDate" data-vv-name="headerForm.updDate" />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-dialog v-model="showUserHelpList" width="1280px">
      <user-help-list @close="showUserHelpList = false" @assign-user="assignUser"></user-help-list>
    </v-dialog>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { survTypeList, recomCompList } from './index'
import UserHelpList from '@/components/core/common/dialog/UserHelpList'

export default {
  data() {
    return {
      labels: {
        survNo: 'Survey No.',
        verCnt: 'Version Count',
        survId: 'Surveyor ID',
        survDate: 'Survey Date',
        polNo: 'Policy No.',
        insdName: "Insured's Name",
        bldgNo: 'Building / House No.',
        unitNo: 'Unit No.',
        addr1: 'Address 1',
        addr2: 'Address 2',
        addr3: 'Address 3',
        addr4: 'Address 4',
        postCode: 'Postal Code',
        survType: 'Survey Type',
        extPhoto: 'External Photo',
        intPhoto: 'Internal Photo',
        plans: 'Plans',
        adjUnit: 'Adjoining Unit',
        contactName: 'Contact Person',
        telNo: 'Contact No.',
        nxtSurvBy: 'Resurvey By',
        updDate: 'Update Date',
        recomComp: 'Recommendation Compliance',
        remarks: "Underwriter's Comments and Recommendations",
        uwIdConv: 'Underwriter ID',
        nxtSurvDate: 'Resurvey Date'
      },
      headerForm: {
        survNo: undefined,
        verCnt: 0,
        survId: undefined,
        survDate: new Date(),
        polNo: undefined,
        insdName: undefined,
        bldgNo: undefined,
        unitNo: undefined,
        addr1: undefined,
        addr2: undefined,
        addr3: undefined,
        addr4: undefined,
        postCode: undefined,
        survType: undefined,
        extPhoto: false,
        intPhoto: false,
        plans: false,
        adjUnit: undefined,
        contactName: undefined,
        telNo: undefined,
        nxtSurvBy: undefined,
        updDate: undefined,
        recomComp: undefined,
        remarks: undefined,
        uwIdConv: undefined,
        nxtSurvDate: undefined
      },
      tabNav: 0,
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      loadingFlag: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      isMandatory: true,
      isOptional: false,
      promptRemoveNameAddrMsg: 'Do you want to remove Name, Address(1-4), Postal Code?',
      survTypeList: [],
      recomCompList: [],
      showPromptLeave: true,
      showUserHelpList: false,
      userFieldName: undefined
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    filterSurvTypeList() {
      return this.survTypeList.filter((list) => {
        return list.value === parseInt(this.headerForm.survType)
      })
    },
    filterRecomCompList() {
      return this.recomCompList.filter((list) => {
        return list.value === parseInt(this.headerForm.recomComp)
      })
    }
  },
  methods: {
    async doInit() {
      if (this.riskSurveyMode === 'New' && this.riskSurveyMaster.survNo === null) {
        this.getSurvNo()
      }
      this.loadInit()
    },
    async loadInit() {
      this.headerForm.survNo = this.riskSurveyMaster.survNo
      this.headerForm.verCnt = this.riskSurveyMaster.verCnt
      this.headerForm.survId = this.riskSurveyMaster.survId
      this.headerForm.survDate = this.riskSurveyMaster.survDate
      this.headerForm.polNo = this.riskSurveyMaster.polNo
      this.headerForm.insdName = this.riskSurveyMaster.insdName
      this.headerForm.bldgNo = this.riskSurveyMaster.bldgNo
      this.headerForm.unitNo = this.riskSurveyMaster.unitNo
      this.headerForm.addr1 = this.riskSurveyMaster.addr1
      this.headerForm.addr2 = this.riskSurveyMaster.addr2
      this.headerForm.addr3 = this.riskSurveyMaster.addr3
      this.headerForm.addr4 = this.riskSurveyMaster.addr4
      this.headerForm.postCode = this.riskSurveyMaster.postCode
      this.headerForm.survType = parseInt(this.riskSurveyMaster.survType)
      this.headerForm.extPhoto = this.riskSurveyMaster.extPhoto
      this.headerForm.intPhoto = this.riskSurveyMaster.intPhoto
      this.headerForm.plans = this.riskSurveyMaster.plans
      this.headerForm.adjUnit = this.riskSurveyMaster.adjUnit
      this.headerForm.contactName = this.riskSurveyMaster.contactName
      this.headerForm.telNo = this.riskSurveyMaster.telNo
      this.headerForm.nxtSurvBy = this.riskSurveyMaster.nxtSurvBy
      this.headerForm.updDate = this.riskSurveyMaster.updDate
      this.headerForm.recomComp = parseInt(this.riskSurveyMaster.recomComp)
      this.headerForm.remarks = this.riskSurveyMaster.remarks
      this.headerForm.uwIdConv = this.riskSurveyMaster.uwIdConv
      this.headerForm.nxtSurvDate = this.riskSurveyMaster.nxtSurvDate
    },
    async getSurvNo() {
      const apiURI = this.riskSurveyMenu.getSurvNo
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data
          if (data) {
            this.headerForm.survNo = data.survNo
          }
          this.$store.dispatch('storeSurveyMaster', this.headerForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doReset() {
      this.getSurvNo()
      this.headerForm.survId = ' '
      this.headerForm.survDate = new Date()
      this.headerForm.insdName = undefined
      this.headerForm.bldgNo = undefined
      this.headerForm.unitNo = undefined
      this.headerForm.addr1 = undefined
      this.headerForm.addr2 = undefined
      this.headerForm.addr3 = undefined
      this.headerForm.addr4 = undefined
      this.headerForm.postCode = undefined
      this.headerForm.survType = undefined
      this.headerForm.extPhoto = false
      this.headerForm.intPhoto = false
      this.headerForm.plans = false
      this.headerForm.adjUnit = undefined
      this.headerForm.contactName = undefined
      this.headerForm.telNo = undefined
      this.headerForm.nxtSurvBy = undefined
      this.headerForm.updDate = undefined
      this.headerForm.recomComp = undefined
      this.headerForm.remarks = undefined
      this.headerForm.uwIdConv = undefined
      this.headerForm.nxtSurvDate = undefined
    },
    getHelpList(fieldName) {
      this.showUserHelpList = true
      this.userFieldName = fieldName
    },
    assignUser(user) {
      if (this.userFieldName === 'survId') {
        this.headerForm.survId = user.usrId
      } else {
        this.headerForm.nxtSurvBy = user.usrId
      }
      this.showUserHelpList = false
    },
    getHeaderForm() {
      return this.headerForm
    },
    formatDate(date) {
      return formatDisplayDate(date)
    }
  },
  created() {
    this.survTypeList = survTypeList
    this.recomCompList = recomCompList
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {
    UserHelpList
  }
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
